import React, { useEffect,useState } from 'react';

import { prominent } from 'color.js';
import ConvertNum from '../ConvertNumbers/useConvertLargeNum.js';
const Engagement = (props) => {
    const[BGColor,setBGColor] = useState(null)
    
    useEffect(()=>{
        if(props.data){
            if(props.data.user_avatar.length>2){
                  // Use relative URL to avoid CORS issues during development
                const imageUrl = "/geniuxmusic/api/media/avatars/smaller/?file_name="+props.data.user_avatar;
                prominent(imageUrl,{format: 'hex',group: 30}).then(colors => {
                    setBGColor(colors[1]) 
                }).catch(error => {
                    console.error('Error extracting color from image:', error);
                    setBGColor('#181818');
                })
            }else{
                setBGColor('#181818') 
            }
        }
        
    },[props.data])
  return (
    <>
        <div className="htitle">
            <div className="lft"><p>Engagement</p></div>
        </div>           
        <div className="card004">
            <div className="background" style={{'--before-bg': BGColor}}> </div>
            <div className="contain">
                <div className="kpi"> 
                    <p><ConvertNum num = {props.data.total_plays}/></p>
                    <p>Streams</p>
                </div>
                <div className="kpi"> 
                    <p><ConvertNum num = {props.data.total_likes}/></p>
                    <p>Likes</p>
                </div>
                <div className="kpi"> 
                    <p><ConvertNum num = {props.data.total_downloads}/></p>
                    <p>Downloads</p>
                </div>
            </div>
            
        </div>
        
    </>
  )
}

export default Engagement